// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define, system_db, server_conf, deps = ['lodash4', 'cookie',
    '/util/url.js', '/util/escape.js', '/util/lang.js'];
let is_mdoc, is_node = typeof module=='object' && module.exports;
if (is_node)
{
    var define_node = require('../../../../util/require_node.js')
        .define(module, '..');
    system_db = require('../../../../system/db/db.js');
    server_conf = system_db.use('server_conf', 'lum');
    define = function(_deps, fn){ return define_node(deps, fn); };
}
else
{
    is_mdoc = /^mdoc/.test(window.location.hostname);
    if (is_mdoc)
        define = function(_deps, fn){ return self.define(deps, fn); };
    else
        define = self.define;
}

define(['lodash4', 'cookie', '/util/url.js', '/util/escape.js',
    '/util/lang.js',
    // XXX vadimr: ignored for k ub_api
    /* brd-build-deps ignore */'/www/lum/pub/config.js'],
    (_, cookie, zurl, zescape, lang_util, config)=>
{

const E = {};

let lum_domain = {}, cn_domain = {}, is_cn;
let init_domain = function(){
    lum_domain = (is_node ? server_conf : config.config).lum_domain||{};
    let add_cn_domain = domain=>{
        if (Array.isArray(domain))
            return void domain.forEach(add_cn_domain);
        cn_domain[domain] = 1;
        cn_domain['www.'+domain] = 1;
    };
    Object.keys(lum_domain).filter(k=>k.includes('cn'))
        .map(k=>lum_domain[k]).forEach(add_cn_domain);
};

E.is_cn = host=>is_node ? cn_domain[host] : is_cn;

E.lum_domain = function(h){
    return E.is_cn(h) ? lum_domain.www_cn : lum_domain.www;
};

E.lum_second_level_domain = function(h){
    return E.lum_domain(h).replace('www.', '');
};

E.lum_domain_sdk = function(h){
    return lum_domain.www_sdk_cp ? lum_domain.www_sdk_cp : E.lum_domain(h); };

E.get_lum_domain_conf = ()=>lum_domain;

E.lum_mail_domain = function(h){
    let mail = E.is_cn(h) ? lum_domain.mail_cn : lum_domain.mail;
    if (!is_mdoc && mail=='luminati.io')
        mail = 'brightdata.com';
    return mail;
};

E.is_sitemap_domain = h=>h==lum_domain.www_cn || h==lum_domain.www;

let www_valid_lang = {ru: 1, es: 1, 'pt-br': 1, fr: 1, tr: 1, ja: 1, ko: 1};

E.is_lang_valid = function(hostname, path){
    let parts = zurl.parse(path);
    let lang = zurl.qs_parse(parts.query||'').lang;
    if (hostname==lum_domain.www_cn)
        return !lang;
    if (hostname==lum_domain.www)
        return !lang || lang in www_valid_lang;
    return false;
};

E.check_domains = (url, domains)=>{
    if (!url)
        return false;
    let hostname = zurl.parse(url).hostname||'';
    let parts = hostname.split('.').reverse().slice(1, 3);
    return _.intersection(parts, domains).length>0;
};

E.is_organic = referrer=>{
    let pre_organic = E.check_domains(referrer,
        ['google', 'yahoo', 'bing', 'duckduckgo', 'yandex', 'baidu',
        'coccoc', 'naver', 'swurl', 'brave', 'metager']);
    return pre_organic && !referrer.startsWith('https://accounts.google.')
        && !referrer.startsWith('https://mail.google.com');
};

E.make_canonical = (hostname, pathname, query)=>{
    pathname = (pathname||'/').toLowerCase();
    let lang = query && query.lang;
    if (lang && lang=='zh-hans')
    {
        hostname = lum_domain.www_cn;
        lang = null;
    }
    else if (lang)
    {
        hostname = lum_domain.www;
        lang = lang=='en' ? null : lang;
    }
    else
        hostname = E.lum_domain(hostname);
    if (pathname=='/locations'||pathname.includes('/locations/'))
        lang = null;
    let qs = lang ? '?'+zurl.qs_str({lang}) : '';
    return `https://${hostname}${pathname}${qs}`;
};

E.redirect_if_needed = function(lang){
    if (!is_cn && lang=='zh-hans' && lum_domain.www_cn ||
        is_cn && lang!='zh-hans' && lum_domain.www)
    {
        let u = new URL(location.href);
        u.host = is_cn ? lum_domain.www : lum_domain.www_cn;
        let mkt_sid3 = cookie.get('mkt_sid3');
        if (mkt_sid3)
            u.searchParams.set('mkt_sid3', mkt_sid3);
        window.location = u.toString();
        return true;
    }
};

E.get_mailto_href = opt=>{
    return 'mailto:'+opt.to+'?'+['cc', 'bcc', 'subject', 'body']
        .map(part=>opt[part] ? part+'='+encodeURIComponent(opt[part]) : '')
        .filter(Boolean).join('&');
};

E.lum_lang = function(url, hostname, opt={}){
    let languages = opt.languages
        || _.get(config, 'config.supported_languages', []);
    if (opt.use_unsupported_languages)
        languages = [];
    let parts = zurl.parse(url);
    return E.is_cn(parts.hostname||hostname)
        ? 'zh-hans'
        : lang_util.hostname_to_locale(parts.hostname||hostname, languages);
};

E.lum_lang_url = function(url, lang){
    let parts = zurl.parse(url);
    let qs = zurl.qs_parse(parts.query||'');
    delete qs.lang;
    let qs_str = '';
    if (Object.keys(qs).length>0)
        qs_str = '?'+zescape.qs(qs);
    parts.path = parts.pathname+qs_str;
    const new_hostname = lang_util.locale_to_hostname(lang);
    parts.host = parts.host.replace(parts.hostname, new_hostname);
    parts.hostname = new_hostname;
    delete parts.hash;
    return zurl.uri_obj_href(parts);
};

E.init = function(){
    if (is_node)
        system_db.on('server_conf', init_domain, 'lum');
    else
    {
        init_domain();
        is_cn = config.config.is_cn;
    }
};

if (!is_mdoc)
    E.init();

return E; }); // eslint-disable-line
